'use strict';

export default angular
  .module('maestro.filters.device-icon', [])

  /**
   * Find available icon to render by icon name passed from server.
   * @param {string} deviceIconName
   * @param {'l' | 'r' | 's'} [preferredStyle]
   */
  .filter('deviceIcon', function(IconService) {
    return function(deviceIconName, preferredStyle) {
      if (!deviceIconName) {
        return deviceIconName;
      }
      deviceIconName = deviceIconName.toLowerCase();

      if (!preferredStyle || !['l', 'r', 's'].includes(preferredStyle)) {
        preferredStyle = 'r';
      }

      return IconService.getServerIcon(deviceIconName, preferredStyle);
    };
  })

  .name;
